/* SPDX-FileCopyrightText: Copyright (c) 2026 NVIDIA CORPORATION & AFFILIATES. All rights reserved. */
/* SPDX-License-Identifier: Apache-2.0 */

:host {
  --width: 100%;
  --padding: 0 var(--nve-ref-size-200);
  --font-size: var(--nve-ref-font-size-100);
  --font-weight: var(--nve-ref-font-weight-medium);
  --border-radius: var(--nve-ref-border-radius-sm);
  --color: var(--nve-sys-text-muted-color);
  --height: var(--nve-ref-size-800);
  --cursor: pointer;
  --text-transform: initial;
  --nve-sys-interaction-state-ratio: 0;
}

[internal-host] {
  width: var(--width);
  gap: var(--nve-ref-space-xs);
  padding: var(--padding);
  height: var(--height);
  color: var(--color);
  font-weight: var(--font-weight);
  font-size: var(--font-size);
  line-height: var(--nve-ref-font-size-500);
  background-image: linear-gradient(
    color-mix(
        in oklab,
        var(--nve-sys-interaction-state-base) 100%,
        var(--nve-sys-interaction-state-mix) var(--nve-sys-interaction-state-ratio)
      )
      0 0
  ) !important;
  inset: var(--border-inset);
  border-radius: var(--border-radius);
  cursor: var(--cursor);
  text-transform: var(--text-transform);
  display: inline-flex;
  align-items: center;
  border: 0;
  position: relative;
}

:host(:state(selected)) {
  --color: var(--nve-sys-text-emphasis-color);
  --font-weight: var(--nve-ref-font-weight-semibold);
}

:host(:state(selected)) ::slotted(nve-icon) {
  --color: var(--nve-sys-interaction-color);
}

:host(:hover:not(:state(disabled), :state(selected))) {
  --color: var(--nve-sys-text-emphasis-color);
  --nve-sys-interaction-state-ratio: var(--nve-sys-interaction-state-ratio-hover);
}

:host(:state(disabled)) {
  --color: var(--nve-sys-interaction-disabled-color);
  --cursor: not-allowed;
}

:host(:is(:focus, :state(focused))) [internal-host] {
  outline-offset: -3px;
  outline: 5px auto -webkit-focus-ring-color; /* var(--nve-ref-outline-webkit) */
  outline: Highlight solid 2px; /* --nve-ref-outline */
}

::slotted(a) {
  text-decoration: var(--text-decoration) !important;
  color: var(--color) !important;
  gap: var(--gap) !important;
  display: flex !important;
  align-items: center !important;
  outline: 0;
}

::slotted(a)::after {
  display: block;
  content: ' ';
  inset: 0;
  position: absolute;
}
